<template>
  <vs-card>
    <div slot="header">
      <h3>Croqui do Sinistro</h3>
    </div>
    <div>
      <!-- não usuaremos o google maps por enquanto -->
      <!-- <iframe
        v-if="dataMapa"
        width="100%"
        height="350"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        :src="`https://maps.google.com/maps?q=${dataMapa.lat},${dataMapa.lon}&hl=pt-br&z=15&amp;output=embed`"
      ></iframe>
      <p>
        {{ endereco }}
      </p> -->
      <!-- não usuaremos o google maps por enquanto -->

      <vue-editor
        v-model="formLocalEvento.local"
        :editor-toolbar="customToolbar"
      ></vue-editor>

      <div v-if="locaisEventos.length" class="mt-10 LocalEvento_container">
        <table>
          <thead>
            <th style="width: 50%">Local</th>
            <th style="width: 30%">Usuário</th>
            <th style="width: 10%">Data</th>
            <th style="width: 10%">Hora</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in locaisEventos" :key="index">
              <td><span v-html="item.local"></span></td>
              <td>{{ item.usuario }}</td>
              <td>{{ formataDataMomentJS(item.createdAt) }}</td>
              <td>{{ pegarHora(item.createdAt) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="mt-10 mb-10">
      <h3>Adicionar fotos</h3>
    </div>

    <uploadFileDragDown
      texto="Arraste suas imagens aqui ou clique abaixo para fazer o upload"
      :extensoesPermitidas="'png-jpg-jpeg-gif'"
      @files="handleFiles"
    />

    <div class="mt-10">
      <vs-card
        class="image-preview mt-10 mb-10"
        v-for="(item, index) in fotosCroqui"
        :key="index"
      >
        <div class="p-2 break-all">
          <!-- Legenda -->
          <p>
            {{ item.legenda ? item.legenda : item.nome }}
          </p>
          <!-- Data e Hora -->
          <p>
            {{ formataDataMomentJS(item.updatedAt, 'DD/MM/YYYY HH:mm') }}
          </p>
          <!-- Usuario -->
          <p>
            {{ item.nomeUsuario }}
          </p>
        </div>
        <div class="image-inner">
          <img
            :src="item.nome"
            alt="image preview"
            @mouseenter="showButtons = true"
            @mouseleave="showButtons = false"
          />
        </div>

        <div class="image-buttons">
          <vs-button color="danger" @click="deleteFoto(item)"
            ><feather-icon icon="Trash2Icon"
          /></vs-button>
        </div>
      </vs-card>
    </div>
  </vs-card>
</template>

<script>
// import axios from 'axios';
import customToolbar from './../../../../../components/editor/config';
import { FOTO_REFERENTE_CROQUI } from '../../shared/const';
import functions from '../../../../../utils/functions';
import service from '../../../../../services';
import notify from '../../../../../utils/notify';
import uploadFileDragDown from './../../../../../components/file-upload/upload-dragdown.vue';
import { VueEditor } from 'vue2-editor';

export default {
  components: {
    VueEditor,
    uploadFileDragDown,
  },
  props: ['formData'],
  watch: {
    formData(value) {
      // this.getLatLon(value.enderecoEvento);

      const { idEvento } = this.formData;
      const { idUsuario } = functions.getDecoded(localStorage);

      this.idEvento = idEvento;
      this.idUsuario = idUsuario;

      this.formLocalEvento.idEvento = idEvento;
      this.formLocalEvento.idUsuario = idUsuario;
      this.formLocalEvento.local  = null
      
      // eslint-disable-next-line vue/no-mutating-props
      this.formData.novoLocalEvento = this.formLocalEvento;

      this.locaisEventos = value.listLocaislEvento;
      this.fotosCroqui = value.listFotosCroqui;
    },
  },
  data() {
    return {
      idEvento: null,
      idUsuario: null,
      // endereco: null,
      // dataMapa: null,
      customToolbar,
      locaisEventos: [],
      formLocalEvento: {
        idEvento: null,
        local: null,
        idUsuario: null,
      },
      files: [],
      fotosCroqui: [],
      idReferente: FOTO_REFERENTE_CROQUI,
      formataDataMomentJS: functions.formataDataMomentJS,
      pegarHora: functions.pegarHora,
    };
  },
  methods: {
    // crateURLAddress(value) {
    //   let address = '';
    //   const itemAdress = ['endereco', 'numero', 'bairro', 'cidade', 'estado'];
    //   itemAdress.forEach((element) => {
    //     if (value[element]) {
    //       address += ` ${value[element]}`;
    //     }
    //   });
    //   if (address.length) {
    //     this.endereco = address;
    //     const uri = encodeURI(address.trim());
    //     const url = `https://nominatim.openstreetmap.org/search.php?q=${uri}&format=jsonv2`;
    //     return url;
    //   }
    //   return null;
    // },
    // async getLatLon(value) {
    //   const url = this.crateURLAddress(value);
    //   if (!url) {
    //     return;
    //   }
    //   try {
    //     const response = await axios.get(url);
    //     const result = response.data;
    //     if (!result.length) {
    //       notify.notifyFail(this.$vs, 'Falha ao carregar o local do evento');
    //       return;
    //     }
    //     const [data] = result;
    //     const { lat, lon } = data;
    //     this.dataMapa = { lat, lon };
    //   } catch (error) {
    //     notify.notifyFail(this.$vs, 'Falha ao carregar o local do evento');
    //   } finally {
    //     this.$vs.loading.close();
    //   }
    // },
    async handleFiles(files) {
      this.files = files;
      // this.files = values.map((v) => {
      //   return {
      //     ...v,
      //     url: URL.createObjectURL(v),
      //   };
      // });

      await this.uploadAWS();
    },
    async uploadAWS() {
      try {
        const formDataSend = new FormData();

        this.files.forEach((file) => {
          formDataSend.append('files', file);
        });

        this.$vs.loading();

        const { uploadedFiles } = await service.uploadAll(
          'upload-multi',
          'Eventos/' + this.idEvento,
          formDataSend,
        );

        await this.uploadFotos(uploadedFiles);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async uploadFotos(awsLinks) {
      try {
        const fotos = this.files.map((f, index) => {
          return {
            idEvento: this.idEvento,
            nome: awsLinks[index],
            legenda: f.name.split('.')[0],
            idFotoReferente: this.idReferente,
            uploadBy: this.idUsuario,
          };
        });

        const result = await service.post(
          'eventos2',
          'registrar-fotos-documentos',
          fotos,
        );

        // POG
        setTimeout(() => {
          this.fotosCroqui = result.data;
        }, 500);

        notify.notifySuccess(
          this.$vs,
          'Upload das fotos concluído com sucesso!',
        );

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async deleteFoto(foto) {
      try {
        const objSend = {
          idEvento: this.idEvento,
          idFotoReferente: this.idReferente,
          ids: [foto.idEventoFoto],
        };

        this.$vs.loading();

        const result = await service.post(
          'eventos2',
          'deletar-fotos-documentos',
          objSend,
        );

        this.fotosCroqui = result.data;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  mounted() {
    // this.getLatLon(this.formData.enderecoEvento);
  },
};
</script>
<style lang="scss" scoped>
.LocalEvento {
  font-size: 1em;

  &_container {
    border-radius: 16px;
    background: #fff;
    box-shadow: 0px 0px 12px 4px rgba(0, 0, 0, 0.06);

    table {
      border-spacing: 0px;
      border-radius: 16px;
      overflow: hidden;
      width: 100%;

      width: 100%;

      th {
        background: rgba(195, 225, 255, 0.5);
        color: #114880;
        font-size: 14px;
        text-transform: uppercase;
        padding: 16px;
      }

      td {
        padding: 16px;
        vertical-align: top;
      }

      tr:nth-child(even) {
        background: #f5f5f5;
      }
    }
  }
}

.image-preview {
  position: relative;
  .image-inner {
    width: 100%;
    padding-top: 50%; /* Define a altura em relação à largura */
    position: relative;
    overflow: hidden;
  }

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 16px;
    object-fit: cover;
  }
}

.image-buttons {
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.5s ease;
  button {
    transition: margin-top 0.5s ease;
    margin-top: 0em;
    margin-right: 2em;
  }
}

.image-preview:hover .image-buttons {
  opacity: 1;
}

.image-preview:hover .image-buttons button {
  margin-top: 1em;
}
</style>
<style src="./../../../../../components/editor/style-editor.css"></style>
